import { render, staticRenderFns } from "./FacSubordinados.vue?vue&type=template&id=08ca8351&"
import script from "./FacSubordinados.vue?vue&type=script&lang=js&"
export * from "./FacSubordinados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports